import { obterPermissao } from "app/use-cases/obterPermissao";
import { ControllerBase } from "controllerBase";
const jQuery = require('jquery')
const ko = require('knockout')

declare var window:any;

const GridController = ControllerBase.extend({
    name: "GridController",

    initialize: function () {

        if (!this.el) {
            return;
        }

        $(this.el).attr("instantiated", true);

        var row = $("tr:first", $(this.el));

        if (!row || row.length === 0) {
            return;
        }

        var columns = $("[column]", row);

        var self = this;
        this.tamanhoFonte = 13;
        this.id = 0;

        $.each(columns,
            function () {
                self.addColumn(this);
            });

        this.getData();
    },

    addColumn: function (td) {

        if (!td) {
            return;
        }

        if (!this.columns) {
            this.columns = new Array();
        }

        var parametroAplicado = $(this.td).attr("parametro-aplicado");

        var columnData = JSON.parse("{" + $(td).attr("column") + "}");
        columnData.el = td;
        columnData.parametroAplicado = parametroAplicado;

        this.columns.push(columnData);
    },

    updateColumns: function () {

        var row = $("tr:first", $(this.el));

        if (!row || row.length === 0) {
            return;
        }

        var columns = $("[column]", row);

        var self = this;

        $.each(columns,
            function () {

                var columnData = JSON.parse("{" + $(this).attr("column") + "}");
                var arr = global.where(self.columns, { nome: columnData.nome });

                if (arr && arr.length > 0) {
                    var column = arr[0];


                    var parametroAplicado = $(this).attr("parametro-aplicado");

                    column.el = this;
                    column.parametroAplicado = parametroAplicado;
                }


            });


    },

    removerElementosAnteriores: function () {  // FNX-3819
        if (this.botaoRecolher) {
            this.botaoRecolher.remove();
        }

        if (this.botaoAumentarFonte) {
            this.botaoAumentarFonte.remove();
        }

        if (this.botaoDiminuirFonte) {
            this.botaoDiminuirFonte.remove();
        }

        if (this.colunaConfGrid) {
            this.colunaConfGrid.hide();
            this.colunaConfGrid.remove();
        }

        if (this.linhaConfGrid) {
            this.linhaConfGrid.hide();
            this.linhaConfGrid.remove();
        }
    },

    renderActionButton: function () {  // FNX-3819
        self = this;
        this.removerElementosAnteriores()
        if ($(this.el).attr("showActionButtons")) {

            if (this.actionButtonGroup) {
                this.actionButtonGroup.remove();
            }

            return;
        }

        if (this.columns.length <= 0)
            return;

        //global.blockUI();
        this.corpoTabela = $(this.el).find('tbody');
        this.cabecalhoTabela = $(this.el).find('thead');
        this.tabela = $(this.el);

        if (this.id > 0 && this.nome !== "" && this.tamanhoFonte > 0) {
            this.aplicarTamanhoFonte(this.tamanhoFonte);
        }

        if (this.actionButtonGroup) {
            this.actionButtonGroup.remove();
        }
        this.actionButtonGroup = $("<div>", { 'class': "button-group", 'style': "margin-right:10x; display: none;" });
        this.actionButton = $("<button>", { 'id': "engrenagemGrid", 'class': "btn btn-default btn-sm dropdown-toggle", 'data-toggle': "dropdown", 'style': "display: none;" });
        this.actionButtonGroup.append(this.actionButton);

        var span1 = $("<span>", { 'class': "glyphicon glyphicon-cog" });
        this.actionButton.append(span1);

        var span2 = $("<span>", { 'class': "caret" });
        this.actionButton.append(span2);

        this.renderColumns();
        this.actionButton.dropdown();


        var colunaConf = $("<th>", { 'id': "colunaConfiguracaoGrid", 'colspan': "999", 'tamanho-fonte-grid': "false" }); // FNX-3819 - inicio
        colunaConf.css("z-index", "1020")

        var idCorpoTabela = this.corpoTabela[0].id;
        $(colunaConf).attr('data-tabela-destino', idCorpoTabela);

        this.botaoRecolher = $("<button>", { 'class': "btn caret-icon fa fa-caret-up no-global-button", 'id': "recolher_configuracao_grid", 'style': "color: black;background-color: transparent;line-height: 0;", 'title': "Mostra/Esconde as configurações" });
        colunaConf.append(this.botaoRecolher);
        colunaConf.append(this.actionButtonGroup);

        this.botaoAumentarFonte = $("<button>", { 'class': "btn btn-default btn-sm", 'id': "aumentar-fonte", 'style': "display: none;", 'title': "Aumenta o tamanho da fonte", 'text': "A+" });
        colunaConf.append(this.botaoAumentarFonte);
        this.botaoDiminuirFonte = $("<button>", { 'class': "btn btn-default btn-sm", 'id': "diminuir-fonte", 'style': "display: none; margin-right: 20px;", 'title': "Diminui o tamanho da fonte", 'text': "A-" });
        colunaConf.append(this.botaoDiminuirFonte);

        var linhaConf = $("<tr>", { 'id': "linhaConfiguracaoGrid", 'height': '10px' });
        linhaConf.append(colunaConf);


        this.cabecalhoTabela.prepend(linhaConf);
        this.linhaConfGrid = linhaConf;
        this.colunaConfGrid = colunaConf; // FNX-3819 - fim

        this.actionButtonGroup.on("show.bs.dropdown",
            $.proxy(function () {
                var scrollParentLeft = this.actionButtonGroup.scrollParent &&
                    this.actionButtonGroup.scrollParent().scrollLeft() > 0
                    ? this.actionButtonGroup.scrollParent().scrollLeft()
                    : 0;

                if (this.actionButtonGroup.parents('div.modal[role=dialog]').length === 0) {
                    scrollParentLeft = 0;
                }

                this.ulContextMenu.css("top", this.actionButtonGroup.position().top + this.actionButtonGroup.height());
                // this.ulContextMenu.css("left", ((this.actionButtonGroup.position().left - 69) + scrollParentLeft) - (this.ulContextMenu.width() / 2) + 20);
            }, this));

        this.actionButtonGroup.on('shown.bs.dropdown',
            $.proxy(function () {
                var scrollParentLeft = this.actionButtonGroup.scrollParent &&
                    this.actionButtonGroup.scrollParent().scrollLeft() > 0
                    ? this.actionButtonGroup.scrollParent().scrollLeft()
                    : 0;

                if (this.actionButtonGroup.parents('div.modal[role=dialog]').length === 0) {
                    scrollParentLeft = 0;
                }

                if (scrollParentLeft) {
                    this.actionButtonGroup.scrollParent()
                        .scrollLeft(this.actionButtonGroup.position().left + this.ulContextMenu.width());
                }
            }, this));

        this.botaoRecolher.on('click', $.proxy(function () {
            if (this.actionButtonGroup.is(":hidden")) {
                this.botaoRecolher.removeClass('fa-caret-up').addClass('fa-caret-down')
                this.actionButtonGroup.show();
                this.actionButton.show();
                this.botaoDiminuirFonte.show();
                this.botaoAumentarFonte.show();
            }
            else {
                this.botaoRecolher.removeClass('fa-caret-down').addClass('fa-caret-up')
                this.actionButtonGroup.hide();
                this.actionButton.hide();
                this.botaoDiminuirFonte.hide();
                this.botaoAumentarFonte.hide();
            }
        }, this));

        this.botaoAumentarFonte.on('click', $.proxy(function () {
            this.aplicarTamanhoFonte(this.tamanhoFonte + 1)
            this.salvarTamanhoFonte();
        }, this));

        this.botaoDiminuirFonte.on('click', $.proxy(function () {
            this.aplicarTamanhoFonte(this.tamanhoFonte - 1)
            this.salvarTamanhoFonte();
        }, this));

        this.permitidoAcessarEngrenagem();
    },

    aplicarTamanhoFonte: function (tamanho) { // FNX-3819
        if (this.validarFaixaTamanhoFonte(tamanho)) {
            this.tamanhoFonte = tamanho;

            if (this.corpoTabela) {
                this.corpoTabela.css('font-size', this.tamanhoFonte + 'px');
            }


            if (this.cabecalhoTabela) {
                var tam = 13
                if (this.tamanhoFonte < 13)
                    tam = this.tamanhoFonte;
                if (this.cabecalhoTabela && this.cabecalhoTabela.length > 0) {
                    this.cabecalhoTabela.css('font-size', tam + 'px');
                }

                if (this.tabela && this.tabela.length > 0) {
                    try {
                        //this.tabela.find('tfoot tr').css('font-size', tam + 'px');
                        this.tabela.find('tfoot').css('font-size', tam + 'px');
                    }
                    catch (error) { } // nao faz nada
                }
            }
        }
    },
    validarFaixaTamanhoFonte: function (tamanho) { // FNX-3819

        var tamMin = 8;
        var tamMax = 26;
        if (this.botaoAumentarFonte && this.botaoAumentarFonte.length > 0)
            this.botaoAumentarFonte.prop("disabled", tamMax <= tamanho);


        if (this.botaoDiminuirFonte && this.botaoDiminuirFonte.length > 0)
            this.botaoDiminuirFonte.prop("disabled", tamMin >= tamanho);

        return (tamanho >= tamMin && tamanho <= tamMax);
    },
    salvarTamanhoFonte: function () { // FNX-3819
        var self = this;

        global.ajax({
            url: '/Usuario/TamanhoFonteGrid',
            type: 'post',
            data: { tamanho: self.tamanhoFonte, idGrid: self.id }
        });
    },

    permitidoAcessarEngrenagem: async function () { // FNX-3819
        var self = this;

        const permitidoFuncionalidade_ORCAMENTO_ACESSO_ENGRENAGEM_GRID =  await obterPermissao({
            funcionalidade: "ORCAMENTO_ACESSO_ENGRENAGEM_GRID"
        })

        if (!permitidoFuncionalidade_ORCAMENTO_ACESSO_ENGRENAGEM_GRID) {
            $("#engrenagemGrid").remove();
        }

    },

    renderColumns: function () {

        if (this.ulContextMenu) {
            this.ulContextMenu.remove();
        }


        this.ulContextMenu = $("<ul>", { 'class': "dropdown-menu", role: "menu" });
        this.ulContextMenu.css("left", "auto")
        this.actionButtonGroup.append(this.ulContextMenu);

        var self = this;

        $.each(this.columns,
            function () {

                if (!this.actionButton && (this.parametroAplicado === undefined || this.parametroAplicado !== "esconder") && this.permitido) {
                    var li = $("<li>");
                    self.ulContextMenu.append(li);

                    var a = $("<a>", { href: "#", 'class': "small", tabIndex: -1 });
                    this.checkbox = $("<input>", { type: "checkbox" });
                    this.checkbox.prop("checked", this.selecionada);
                    this.checkbox.change($.proxy(self.columnSelected, self, this));
                    a.append(this.checkbox);
                    a.append("&nbsp;");

                    var text = this.label ? this.label : null;

                    if (!text) {
                        text = $(this.el).text();
                    }

                    a.append(text);
                    li.append(a);
                }
            });
    },

    columnSelected: function (column, e) {

        column.selecionada = column.checkbox.prop("checked");
        this.update();

    },

    getData: function () {

        if (!this.columns || this.columns.length === 0) {
            return;
        }

        var self = this;

        var columnsClone = global.cloneArray(this.columns);


        global.ajax({
            url: GridController.server.getDataUrl,
            type: "get",
            blockUI: false,
            data: {
                token: GridController.server.token,
                codigoUsuario: GridController.server.userId,
                modulo: GridController.server.module,
                nomeGrid: this.nome
            },
            success: function (data) {

                if (!data) {
                    self.update(columnsClone);
                    return;
                }

                self.id = data.Codigo;
                var possuiSelecionada = false;
                self.aplicarTamanhoFonte(data.TamanhoFonte); // FNX-3819
                $.each(data.Colunas,
                    function () {

                        var arr = global.where(self.columns, { nome: this.Nome });
                        var col = arr && arr.length > 0 ? arr[0] : null;

                        if (col) {
                            col.codigo = this.Codigo;
                            col.selecionada = this.Selecionada;
                            col.permitido = this.Permitido;

                            if (!possuiSelecionada && col.selecionada) {
                                possuiSelecionada = true;
                            }
                        }

                    });

                if (!possuiSelecionada) {
                    self.update(columnsClone);
                }

                self.updated = true;
                self.renderActionButton();
                self.aplicarTamanhoFonte(data.TamanhoFonte); // FNX-3819
                self.refresh();
            }
        });
    },

    update: function (columns) {

        if (!columns || columns.length === 0) {
            columns = this.columns;
        }

        if (!columns || columns.length === 0) {
            return;
        }

        var self = this;

        global.ajax({
            url: GridController.server.updateDataUrl,
            type: "post",
            contentType: "application/json",
            data: global.toJSONString({
                token: GridController.server.token,
                codigoUsuario: GridController.server.userId,
                modulo: GridController.server.module,
                nomeGrid: this.nome,
                colunas: columns
            },
                function (key, value) {
                    if (key === "el" || key === "checkbox") {
                        return null;
                    } else {
                        return value;
                    }

                }),
            success: function (data) {

                if (!data) {
                    return;
                }

                self.id = data.Codigo;

                $.each(data.Colunas,
                    function () {

                        var arr = global.where(self.columns, { nome: this.Nome });
                        var col = arr && arr.length > 0 ? arr[0] : null;

                        if (col) {
                            col.codigo = this.Codigo;
                            col.selecionada = this.Selecionada;
                            col.permitido = this.Permitido;
                        }

                    });


                self.refresh();

            }

        });
    },

    refreshAll: function (region) {

        var $region = region;

        if (!(region instanceof jQuery)) {
            $region = $(region);
        }

        this.el = region;
        this.updateColumns();
        this.renderActionButton();
        this.refresh(region);
    },

    refresh: function (region) {

        if (!this.columns || this.columns.length === 0 || !this.updated) {
            return;
        }

        if (!region) {
            region = $(this.el);
        } else if (!(region instanceof jQuery)) {
            region = $(region);
        }

        $.each(this.columns,
            function () {

                if (this.checkbox) {
                    this.checkbox.prop("checked", this.selecionada);
                }

                var col = this;

                var columns = $("[column]", region).filter(function () {
                    var columnData = JSON.parse("{" + $(this).attr("column") + "}");
                    return columnData.nome === col.nome && !columnData.actionButton;
                });


                $.each(columns,
                    function () {
                        if (col.permitido !== undefined && !col.permitido) {
                            columns.remove();
                            columns.attr('permitirmostrar', false);
                        }
                        else if (!col.selecionada) {
                            columns.hide();
                            columns.attr('permitirmostrar', false);
                        } else if (col.parametroAplicado === undefined || col.parametroAplicado !== "esconder") {
                            columns.show();
                        }
                    }
                );
            }
        );

        this.aplicarTamanhoFonte(this.tamanhoFonte);
    }
});

GridController.instantiate = function (el) {

    if (!el) {
        return;
    }

    var gridData = JSON.parse("{" + $(el).attr("grid") + "}");

    var gridController = null;

    if (GridController.instances && GridController.instances.length > 0) {
        var arr = global.where(GridController.instances, { nome: gridData.nome });

        if (arr && arr.length > 0) {
            gridController = arr[0];
            gridController.refreshAll(el);
            return;
        }
    }

    var options = {
        el: el
    };

    $.extend(options, gridData);

    gridController = new GridController(options);

    if (!GridController.instances) {
        GridController.instances = new Array();
    }

    GridController.instances.push(gridController);

};

GridController.get = function (name) {

    if (!GridController.instances || GridController.instances.length === 0) {
        return;
    }
    var arr = global.where(GridController.instances, { nome: name });
    return arr && arr.length > 0
        ? arr[0]
        : null;
}

GridController.start = function (region) {

    if (!GridController.server) {
        return;
    }

    if (region && !(region instanceof jQuery)) {
        region = $(region);
    } else if (!region) {
        region = $("body");
    }

    var grids = $("[grid]", region);
    var rows = $("[column]", region);

    var isGrid = grids && grids.length > 0;
    var isRow = rows && rows.length > 0;

    if (isGrid) {

        var instantiated = false;

        $.each(grids,
            function () {
                if (!$(this).attr("instantiated")) {
                    GridController.instantiate(this);
                    instantiated = true;
                }
            });

        if (instantiated) {
            return;
        }
    }

    if (isRow) {

        var columns = $("[column]", region);

        if (!columns || columns.length === 0) {
            return;
        }

        var columnData = JSON.parse("{" + $(columns[0]).attr("column") + "}");

        if (!columnData) {
            return;
        }

        if (GridController.instances && GridController.instances.length > 0) {
            var arr = global.where(GridController.instances, { nome: columnData.grid });

            if (arr && arr.length > 0) {
                var gridController = arr[0];
                gridController.refresh(region);
                return;
            }
        }
    }
};

(function ($) {
    var modalCallback = $.fn.modal;
    var htmlCallback = $.fn.html;
    var applyBindingsCallback = ko.applyBindings;

    $.fn.html = function () {
        var result = htmlCallback.apply(this, arguments);
        GridController.start(this);
        return result;
    };

    $.fn.modal = function () {
        var result = modalCallback.apply(this, arguments);
        GridController.start(this);
        return result;
    };

    ko.applyBindings = function () {
        var result = applyBindingsCallback.apply(this, arguments);
        if (arguments && arguments.length > 1) {
            GridController.start(arguments[1]);
        }
        return result;
    };

}(jQuery));

window.GridController = GridController

export {GridController}